import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';

@doc.path('/stand_statuses/{?id}')
abstract class AbstractStandStatusModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		partial: string;
	};

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
	@doc.string declare reference: Website_StandStatusReference;
}

export default AbstractStandStatusModel;
